import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { DataTable } from "./DataTable";
import { recordModel } from "./recordModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {

    const { summaryData, invoiceBillExport, invoiceBillExportAttach } = recordModel();

    const desc: IDescription[] = [
        {
            label: "发票金额",
            value: summaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalBillAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "已开票金额",
            value: summaryData?.totalInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "未开票金额",
            value: summaryData?.totalNotInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalNotInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        },
    ]

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_RECORD_EXPORT}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceBillExport}
                    >
                        导出
                    </Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_RECORD_EXPORTATTACH}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceBillExportAttach}
                    >
                        导出附件
                    </Button>
                </YhAuth>
            </div>
        </>
    );

    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}
